
import React, { Component } from 'react'
import axios from 'axios'
import { NotificationManager } from 'react-notifications'
const url = window.location.href;
const params = (new URL(url)).searchParams;
const id = params.get("productid");
const token = localStorage.getItem("token");

const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));
class DeleteReview extends Component {
	constructor(props) {
		super(props)

	}

	changeHandler = e => {
		this.setState({ [e.target.name]: e.target.value })
	}



	submitHandler = e => {
		e.preventDefault()
		console.log(this.state)
		axios
			.delete(`https://shoppee-clone.herokuapp.com/review/${id}/${loggedInUserID}`, {
                headers: { 'Content-Type': 'application/json' }
              })
			.then(response => {
				console.log(response)
				window.location.reload()
			})
			.catch(error => {
				NotificationManager.error('error deleting');
				console.log(error)
			})
	}

	render() {
		if ( token != null) {
			return (
				<div>
				<fieldset class="w-100 col-12 mt-5 d-flex justify-content-around">
				<form  onSubmit={this.submitHandler} action="" method="delete">
				  <button class="btn btn-danger button2" id="checkingout">
				   Delete Reviews <i class="bi bi-x"></i>
				  </button>
			  </form>
			  </fieldset>
			  </div>
			  
			)
		}
		
	}
}

export default DeleteReview;

